@if (show) {
  <div class="sub-nav">
    <ul class="nav">
      <ng-content></ng-content>
    </ul>
  </div>
}
